import React from "react";
import OrderDetailmain from "../components/orders/OrderDetailmain";
import Sidebar from "../components/sidebar";
import Header from "./../components/Header";

const OrderDetailScreen = ({ match }) => {
  const orderId = match.params.id;
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <OrderDetailmain orderId={orderId} />
      </main>
    </>
  );
};

export default OrderDetailScreen;
